(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  class MervauxHighlights extends HTMLElement {
    originals = new WeakMap();
    updateFrame = 0;
    captionPairs = [];
    captionFrame = 0;
    captionObserver = new ResizeObserver(() => this.queueCaptionAlignment());
    observer = new MutationObserver(records => {
      const structuralChange = records.some(record =>
        [...record.addedNodes, ...record.removedNodes].some(node =>
          node instanceof Element && (
            node.matches('.product-grid, li[data-product-id], .mervaux-highlight-config') ||
            node.querySelector('.product-grid, li[data-product-id], .mervaux-highlight-config')
          )
        )
      );
      if (!structuralChange || this.updateFrame) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = 0;
        if (this.isConnected) this.update();
      });
    });

    connectedCallback() {
      this.update();
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.captionObserver.disconnect();
      cancelAnimationFrame(this.updateFrame);
      cancelAnimationFrame(this.captionFrame);
      this.updateFrame = 0;
      this.captionFrame = 0;
    }

    queueCaptionAlignment() {
      if (this.captionFrame) return;
      this.captionFrame = requestAnimationFrame(() => {
        this.captionFrame = 0;
        if (!this.isConnected) return;
        const heights = this.captionPairs.map(pair => Math.max(...pair.map(caption => {
          const boxes = [...caption.children].map(child => child.getBoundingClientRect()).filter(box => box.height > 0);
          return boxes.length ? Math.max(...boxes.map(box => box.bottom)) - Math.min(...boxes.map(box => box.top)) : 0;
        })));
        this.captionPairs.forEach((pair, index) => pair.forEach(caption => {
          const height = `${heights[index]}px`;
          if (caption.style.getPropertyValue('--mervaux-mosaic-caption-height') !== height) caption.style.setProperty('--mervaux-mosaic-caption-height', height);
        }));
      });
    }

    layoutTierMosaic(grid) {
      this.captionObserver.disconnect();
      this.captionPairs = [];
      grid.querySelectorAll('.mervaux-mosaic-caption').forEach(caption => {
        caption.classList.remove('mervaux-mosaic-caption');
        caption.style.removeProperty('--mervaux-mosaic-caption-height');
      });
      if (!this.querySelector('[data-mervaux-tier-mosaic]')) return;
      let row = 1;
      let featureIndex = 0;
      let run = [];
      const place = (card, column, span, startRow, rowSpan = 1) => {
        card.style.setProperty('--mervaux-mosaic-column', `${column} / span ${span}`);
        card.style.setProperty('--mervaux-mosaic-row', `${startRow} / span ${rowSpan}`);
        card.classList.toggle('mervaux-mosaic-feature', rowSpan === 2);
      };
      const flush = () => {
        if (!run.length) return;
        // Only a real adjacent set receives equal cards; a family tag on one piece
        // must not interrupt the gallery. Style and price tiers never create rows.
        const matched = new Set();
        for (let start = 0; start < run.length;) {
          let end = start + 1;
          if (run[start].dataset.familyMatrix === 'true' && run[start].dataset.family) {
            while (end < run.length && run[end].dataset.familyMatrix === 'true' && run[end].dataset.family === run[start].dataset.family) end++;
            if (end - start > 1) for (let index = start; index < end; index++) matched.add(index);
          }
          start = end;
        }
        const equalCards = cards => {
          const columns = cards.length === 2 || cards.length === 4 ? 2 : 3;
          const span = 12 / columns;
          cards.forEach((card, index) => {
            card.classList.remove('mervaux-tier-product--wide', 'mervaux-mosaic-single');
            place(card, index % columns * span + 1, span, row + Math.floor(index / columns));
          });
          row += Math.ceil(cards.length / columns);
        };
        const editorialCards = cards => {
          cards.forEach(card => card.classList.remove('mervaux-tier-product--wide', 'mervaux-mosaic-single'));
          // Four equal closing cards avoid an enlarged orphan after the editorial triples.
          const remainder = cards.length > 1 && cards.length % 3 === 1 ? 4 : cards.length % 3;
          const blocks = (cards.length - remainder) / 3;
          let cursor = 0;
          for (let block = 0; block < blocks; block++) {
            const featureFirstTennis = block === 0 && cards[0].dataset.page === '1' && cards[0].dataset.productId === '15394539405533';
            const featureOnLeft = featureFirstTennis || featureIndex % 2 === 1;
            featureIndex = featureOnLeft ? 0 : 1;
            const smallColumn = featureOnLeft ? 9 : 1;
            const featureCard = cards[cursor + (featureFirstTennis ? 0 : 2)];
            const lowerCard = cards[cursor + (featureFirstTennis ? 2 : 1)];
            const captions = [featureCard, lowerCard].map(card => card.querySelector('.product-card__content > .group-block, .mervaux-editorial-caption'));
            if (captions.every(Boolean)) {
              this.captionPairs.push(captions);
              captions.forEach(caption => {
                caption.classList.add('mervaux-mosaic-caption');
                [...caption.children].forEach(child => this.captionObserver.observe(child));
              });
            }
            if (featureFirstTennis) {
              cards[cursor].classList.toggle('mervaux-tier-product--wide', true);
              place(cards[cursor++], 1, 8, row, 2);
              place(cards[cursor++], 9, 4, row);
              place(cards[cursor++], 9, 4, row + 1);
            } else {
              place(cards[cursor++], smallColumn, 4, row);
              place(cards[cursor++], smallColumn, 4, row + 1);
              cards[cursor].classList.toggle('mervaux-tier-product--wide', true);
              place(cards[cursor++], featureOnLeft ? 1 : 5, 8, row, 2);
            }
            row += 2;
          }
          if (remainder > 0) {
            const columns = remainder === 1 ? 3 : 2;
            const span = 12 / columns;
            for (let index = 0; index < remainder; index++) {
              const card = cards[cursor++];
              place(card, index % columns * span + 1, span, row + Math.floor(index / columns));
              card.classList.remove('mervaux-tier-product--wide');
              card.classList.toggle('mervaux-mosaic-single', remainder === 1);
            }
            row += Math.ceil(remainder / columns);
          }
        };
        let cursor = 0;
        while (cursor < run.length) {
          let end = cursor;
          while (end < run.length && !matched.has(end)) end++;
          if (end > cursor && (end - cursor !== 1 || end === run.length)) {
            editorialCards(run.slice(cursor, end));
            cursor = end;
            continue;
          }
          // A short set shares its closing row with the following pieces. Keep a
          // whole next set at the same scale if it is needed to complete that row.
          const prefixCount = end - cursor;
          while (end < run.length && matched.has(end)) end++;
          const setCount = end - cursor;
          const columns = prefixCount === 0 && (setCount === 2 || setCount === 4) ? 2 : 3;
          while (end < run.length && (end - cursor) % columns !== 0) {
            if (matched.has(end)) {
              const family = run[end].dataset.family;
              do { end++; } while (end < run.length && matched.has(end) && run[end].dataset.family === family);
            } else {
              end++;
            }
          }
          equalCards(run.slice(cursor, end));
          cursor = end;
        }
        run = [];
      };
      for (const item of grid.children) {
        if (item.matches('li[data-product-id]')) {
          if (run.length) {
            if (item.dataset.page !== run[0].dataset.page) flush();
          }
          run.push(item);
        } else if (item.matches('li')) {
          flush();
          item.style.setProperty('--mervaux-mosaic-column', '1 / -1');
          item.style.setProperty('--mervaux-mosaic-row', String(row++));
        }
      }
      flush();
      grid.setAttribute('data-mervaux-mosaic-ready', 'true');
      this.captionObserver.observe(grid);
      this.queueCaptionAlignment();
    }

    update() {
      const grid = this.querySelector('.product-grid');
      if (!grid) return;
      this.observer.disconnect();
      const configs = new Map();
      this.querySelectorAll('.mervaux-highlight-config').forEach(config => {
        if (!configs.has(config.dataset.productId)) configs.set(config.dataset.productId, config);
      });
      const cards = [...grid.children].filter(card => card.matches('li[data-product-id]'));
      const pages = new Map();
      cards.forEach(card => {
        const page = card.dataset.page;
        if (!pages.has(page)) pages.set(page, []);
        pages.get(page).push(card);
      });
      const ordered = [];
      const tierMosaic = Boolean(this.querySelector('[data-mervaux-tier-mosaic]'));
      const familyMatrix = Boolean(this.querySelector('[data-mervaux-family-matrix]'));
      for (const pageCards of pages.values()) {
        pageCards.sort((a, b) => Number(a.dataset.collectionIndex) - Number(b.dataset.collectionIndex));
        const eligible = pageCards.filter(card => card.dataset.highlightEnabled === 'true' && configs.has(card.dataset.productId));
        const rank = [...configs.keys()];
        const highlights = new Map();
        const groupKey = card => `${card.dataset.merchandisingGroup || 'regular'}:${card.dataset.merchandisingTier || ''}:${card.dataset.imageTier}`;
        for (const card of eligible) {
          const key = groupKey(card);
          if (!highlights.has(key)) highlights.set(key, []);
          highlights.get(key).push(card);
        }
        for (const group of highlights.values()) group.sort((a, b) => rank.indexOf(a.dataset.productId) - rank.indexOf(b.dataset.productId));
        for (const card of pageCards) {
          ordered.push(!tierMosaic && !familyMatrix && this.dataset.order === 'blocks' && eligible.includes(card) ? highlights.get(groupKey(card)).shift() : card);
        }
      }
      let highlightIndex = 0;
      for (const card of ordered) {
        const config = card.dataset.highlightEnabled === 'true' ? configs.get(card.dataset.productId) : null;
        const previous = this.originals.get(card);
        if (!config && previous) {
          card.replaceChildren(...previous.nodes);
          card.classList.remove('mervaux-editorial-tile', 'mervaux-editorial-tile--portrait', 'mervaux-editorial-tile--landscape', 'mervaux-editorial-tile--left', 'mervaux-editorial-tile--right');
          card.removeAttribute('data-shopify-editor-block');
          this.originals.delete(card);
        }
        if (!config) continue;
        if (!previous) {
          this.originals.set(card, { nodes: [...card.childNodes], config });
          card.replaceChildren(config.content.cloneNode(true));
        } else if (previous.config !== config) {
          previous.config = config;
          card.replaceChildren(config.content.cloneNode(true));
        }
        let side = config.dataset.side;
        if (side === 'auto') side = this.dataset.side;
        if (side === 'alternate' || !side) side = highlightIndex % 2 === 0 ? 'left' : 'right';
        highlightIndex++;
        card.classList.add('mervaux-editorial-tile');
        for (const value of ['portrait', 'landscape']) card.classList.toggle(`mervaux-editorial-tile--${value}`, config.dataset.format === value);
        for (const value of ['left', 'right']) card.classList.toggle(`mervaux-editorial-tile--${value}`, side === value);
        const editor = config.getAttribute('data-shopify-editor-block');
        if (editor) card.setAttribute('data-shopify-editor-block', editor);
      }
      if (ordered.some((card, index) => card !== cards[index])) {
        // Keep editorial story cards in their original slots.
        const slots = cards.map(card => {
          const slot = document.createTextNode('');
          grid.insertBefore(slot, card);
          return slot;
        });
        ordered.forEach((card, index) => slots[index].replaceWith(card));
      }
      this.layoutTierMosaic(grid);
      this.observer.observe(this, { childList: true, subtree: true });
    }
  }
  if (!customElements.get('mervaux-highlights')) customElements.define('mervaux-highlights', MervauxHighlights);

  class MervauxEditorialCard extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-editorial-switch]');
        if (button) { event.preventDefault(); this.switchImage(); }
        else if (Date.now() < this.suppressUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { capture: true, signal });
      const media = this.querySelector('.mervaux-editorial-media');
      if (!media || !this.querySelector('[data-editorial-switch]')) return;
      media.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || event.target.closest('button')) return;
        this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true, signal });
      media.addEventListener('pointercancel', () => { this.start = null; }, { signal });
      media.addEventListener('pointerup', event => {
        const start = this.start;
        this.start = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this.switchImage();
          this.suppressUntil = Date.now() + 500;
        }
      }, { passive: true, signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    switchImage() {
      const second = this.dataset.view !== '1';
      this.dataset.view = second ? '1' : '0';
      const counter = this.querySelector('[data-editorial-counter]');
      if (counter) counter.textContent = second ? '2 / 2' : '1 / 2';
    }
  }
  if (!customElements.get('mervaux-editorial-card')) customElements.define('mervaux-editorial-card', MervauxEditorialCard);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mervaux-customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mervaux-customer-stories')) {
    customElements.define('mervaux-customer-stories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        if (!this.track || !this.controls) return;
        this.previous = this.controls.querySelector('[data-direction="previous"]');
        this.next = this.controls.querySelector('[data-direction="next"]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'instant' : 'smooth' });
      }
      update() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = overflow <= 2;
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= overflow - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mervaux-home-season"] && !Shopify.designMode) return;
  try {
    
  class MervauxHomeSeason extends HTMLElement {
    layoutFrame = 0;
    titleBlocks = [];
    resizeObserver = new ResizeObserver(() => this.queueLayout());

    connectedCallback() {
      this.titleBlocks = [...this.querySelectorAll('[ref="productTitleLink"] .text-block')];
      this.titleBlocks.forEach(block => {
        [...block.children].forEach(child => this.resizeObserver.observe(child));
      });
      const grid = this.querySelector('.resource-list--grid');
      if (grid) this.resizeObserver.observe(grid);
      this.queueLayout();
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = 0;
    }

    queueLayout() {
      if (this.layoutFrame) return;
      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = 0;
        if (!this.isConnected) return;
        // Measure each name without the previous row's reserved space, so a
        // responsive column change can shrink as well as grow the caption.
        this.titleBlocks.forEach(block => block.style.setProperty('--mervaux-home-name-height', '0px'));
        const rows = new Map();
        this.titleBlocks.forEach(block => {
          const card = block.closest('.resource-list__item');
          const row = Math.round(card.getBoundingClientRect().top);
          if (!rows.has(row)) rows.set(row, []);
          const height = Math.max(0, ...[...block.children].map(child => child.getBoundingClientRect().height));
          const nameHeight = block.querySelector('.mervaux-card-title__name')?.getBoundingClientRect().height || 0;
          rows.get(row).push({ block, height, nameHeight });
        });
        const heights = [...rows.values()].flatMap(row => {
          const nameHeight = Math.max(...row.map(item => item.nameHeight));
          const height = Math.max(...row.map(item => item.height + nameHeight - item.nameHeight));
          return row.map(item => ({ block: item.block, height: `${height}px`, nameHeight: `${nameHeight}px` }));
        });
        heights.forEach(({ block, height, nameHeight }) => {
          block.style.setProperty('--mervaux-home-name-height', nameHeight);
          if (block.style.getPropertyValue('--mervaux-home-title-height') !== height) block.style.setProperty('--mervaux-home-title-height', height);
        });
      });
    }
  }
  if (!customElements.get('mervaux-home-season')) customElements.define('mervaux-home-season', MervauxHomeSeason);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mervaux-lido-hero"] && !Shopify.designMode) return;
  try {
    
 (() => {
   const initialize = (scope) => {
     const sections = scope.matches?.('[data-golden-collection]') ? [scope] : scope.querySelectorAll('[data-golden-collection]');
     sections.forEach((section) => {
       if (section.dataset.motionInitialized) return;
       section.dataset.motionInitialized = 'true';
       const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
       if (section.dataset.animate !== 'true' || reduced.matches || !('IntersectionObserver' in window)) return;
       const observer = new IntersectionObserver((entries) => {
         if (!entries.some((entry) => entry.isIntersecting)) return;
         observer.disconnect();
         if (reduced.matches) return;
         const animations = [];
         const image = section.querySelector('.mervaux-lido-hero__scene img');
         const compactMotion = window.matchMedia('(max-width:989px), (pointer:coarse)').matches;
         if (image?.animate) animations.push(image.animate(
           compactMotion
             ? [{ opacity:.72 }, { opacity:1 }]
             : [{ transform:'scale(1.025)', opacity:.85 }, { transform:'scale(1)', opacity:1 }],
           { duration:compactMotion ? 1100 : 2400, easing:'cubic-bezier(.2,.65,.3,1)' }
         ));
         const copy = section.querySelector('.mervaux-lido-hero__copy');
         if (copy) [...copy.children].forEach((element,index) => {
           if (!element.animate) return;
           animations.push(element.animate([
             { opacity:0, transform:'translateY(12px)' },
             { opacity:1, transform:'translateY(0)' }
           ], { duration:1000, delay:100+index*85, fill:'backwards', easing:'cubic-bezier(.22,1,.36,1)' }));
         });
         const stop = () => { if (reduced.matches) animations.forEach((animation) => animation.cancel()); };
         reduced.addEventListener('change',stop);
         Promise.allSettled(animations.map((animation) => animation.finished)).finally(() => reduced.removeEventListener('change',stop));
       }, {threshold:.08});
       observer.observe(section);
     });
   };
   initialize(document);
   document.addEventListener('shopify:section:load',(event) => initialize(event.target));
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mervaux-pre-holiday"] && !Shopify.designMode) return;
  try {
    
 (() => {
   const initialize = (scope) => {
     const sections = scope.matches?.('[data-golden-editorial]') ? [scope] : scope.querySelectorAll('[data-golden-editorial]');
     sections.forEach((section) => {
       if (section.dataset.motionInitialized) return;
       section.dataset.motionInitialized = 'true';
       const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
       if (section.dataset.animate !== 'true' || reduced.matches || !('IntersectionObserver' in window)) return;
       const observer = new IntersectionObserver((entries) => {
         if (!entries.some((entry) => entry.isIntersecting)) return;
         observer.disconnect();
         if (reduced.matches) return;
         const animations = [];
         const image = section.querySelector('.mervaux-pre-holiday__image img');
         const compactMotion = window.matchMedia('(max-width:989px), (pointer:coarse)').matches;
         if (image?.animate) animations.push(image.animate(
           compactMotion
             ? [{ opacity:.72 }, { opacity:1 }]
             : [{ transform:'scale(1.025)', opacity:.85 }, { transform:'scale(1)', opacity:1 }],
           { duration:compactMotion ? 1100 : 2400, easing:'cubic-bezier(.2,.65,.3,1)' }
         ));
         const copy = section.querySelector('.mervaux-pre-holiday__copy');
         if (copy) [...copy.children].forEach((element,index) => {
           if (!element.animate) return;
           animations.push(element.animate([
             { opacity:0, transform:'translateY(12px)' },
             { opacity:1, transform:'translateY(0)' }
           ], { duration:1000, delay:100+index*85, fill:'backwards', easing:'cubic-bezier(.22,1,.36,1)' }));
         });
         const stop = () => { if (reduced.matches) animations.forEach((animation) => animation.cancel()); };
         reduced.addEventListener('change',stop);
         Promise.allSettled(animations.map((animation) => animation.finished)).finally(() => reduced.removeEventListener('change',stop));
       }, {threshold:.08});
       observer.observe(section);
     });
   };
   initialize(document);
   document.addEventListener('shopify:section:load',(event) => initialize(event.target));
 })();

  } catch(e) { console.error(e); }
})();
})();
